export enum DMSV3_MONITORING_STORAGE_KEYS {
  PageSizePreference = "dmsv3-monitoring-page-size-preference"
}
